const firebaseConfig = {
  apiKey: 'AIzaSyCGG8b0FMQXThCoGn7G-imXEPAUKgQ0pzY',
  authDomain: 'auth.livepaow.com',
  databaseURL: 'https://livepaow.firebaseio.com',
  projectId: 'livepaow',
  storageBucket: 'livepaow.appspot.com',
  messagingSenderId: '921223962908',
  appId: '1:921223962908:web:d57e81be354dd0866e1ad9',
  measurementId: 'G-40K5JJ8DKP'
}

export default firebaseConfig
